import React, { useState, useEffect } from 'react';
import { createRoot } from 'react-dom/client';
import PlaygroundWrapper from './components/playground-wrapper';

const styles = `
  .__textAlignLast fieldset {
    border: none;
    margin: 0 0 1.5em;
    padding: 0;
  }

  .__textAlignLast fieldset legend {
    margin-bottom: 0.5em;
  }

  .__textAlignLast .preview {
    position: relative;
    padding: 3em 1em 1em;
    background: var(--blue-darker);
  }

  .__textAlignLast .preview p code {
    color: var(--grey-darker);
  }

  .__textAlignLast .preview input {
    height: 2.5em;
    width: 2.5em;
    margin: 0 .25em;
  }

  .__textAlignLast fieldset ul {
    list-style: none;
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(8em, 1fr));
    grid-gap: 0.5em;
    margin: 0;
    padding: 0;
  }

  .__textAlignLast fieldset li {
    margin: 0;
    position: relative;
    text-align: center;
  }

  .__textAlignLast fieldset input {
    position: absolute;
    inset: 0;
    opacity: 0;
  }

  .__textAlignLast input:checked + label {
    background-color: var(--blue);
    border-color: var(--blue);
  }

  .__textAlignLast input:disabled + label {
    opacity: 0.675;
  }

  .__textAlignLast fieldset label  {
    display: block;
    border-radius: .25rem;
    padding: 0.5rem 0;
    font-size: 0.75em;
    color: white;
    font-family: var(--coding-font);
    border-bottom: 4px solid var(--currentColor);
    text-align: center;
    transition: background-color .125s ease-in;
    border: 2px solid var(--blue-dark);
    height: 100%;
  }

  .__textAlignLast .prewiew__label {
    position: absolute;
    top: 1em;
    right: var(--grid-outer-padding);
    text-align: right;
    font-size: .75em;
    letter-spacing: 1px;
    font-weight: 700;
    font-family: system-ui, sans-serif;
    color: var(--blue-bright);
    text-transform: uppercase;
  }

  .__textAlignLast .preview__noSupport {
    background: var(--red-dark);
    padding: 1em;
    text-align: center;
    margin-top: 1em;
    border-radius: 0.25em;
  }
`;

const TextAlignLastExplainer = (props) => {
  const availableOptions = [
    { value: 'auto', name: 'auto (initial value)' },
    { value: 'left', name: 'left' },
    { value: 'center', name: 'center' },
    { value: 'right', name: 'right' },
    { value: 'start', name: 'start' },
    { value: 'end', name: 'end' },
    { value: 'justify', name: 'justify' },
  ];

  const availableDirections = [
    {
      value: 'ltr',
      name: 'left-to-right (ltr)',
    },
    {
      value: 'rtl',
      name: 'right-to-left (rtl)',
    },
  ];

  const [optionIndex, setOptionIndex] = useState(0);
  const [directionIndex, setDirectionIndex] = useState(0);
  const [textAlignLastSupported, setTextAlignLastSupported] = useState(true);

  useEffect(() => {
    setTextAlignLastSupported(CSS.supports('text-align-last: justify'));
  }, []);

  return (
    <PlaygroundWrapper>
      <div className="__textAlignLast">
        <fieldset>
          <legend>
            Choose a <code>text-align-last</code> option
          </legend>
          <ul>
            {availableOptions.map((option, index) => {
              const { name } = option;
              return (
                <li key={name}>
                  <input
                    id={name}
                    type="radio"
                    value={index}
                    checked={index === optionIndex ? true : false}
                    disabled={textAlignLastSupported ? false : true}
                    onChange={() => setOptionIndex(index)}
                  />
                  <label htmlFor={name}>{name}</label>
                </li>
              );
            })}
          </ul>
        </fieldset>
        <fieldset>
          <legend>
            Choose a <code>direction</code> option
          </legend>
          <ul>
            {availableDirections.map((direction, index) => {
              const { name } = direction;
              return (
                <li key={name}>
                  <input
                    id={name}
                    type="radio"
                    value={index}
                    checked={index === directionIndex ? true : false}
                    disabled={textAlignLastSupported ? false : true}
                    onChange={() => setDirectionIndex(index)}
                  />
                  <label htmlFor={name}>{name}</label>
                </li>
              );
            })}
          </ul>
        </fieldset>
        <div className="preview">
          <div className="prewiew__label">Preview</div>
          {textAlignLastSupported ? (
            ''
          ) : (
            <div className="preview__noSupport">
              The demo is disabled because it looks like your browser doesn't
              support <code>text-align-last</code> yet.
            </div>
          )}
          <p
            style={{
              direction: availableDirections[directionIndex].value,
              textAlign: 'justify',
              textAlignLast: availableOptions[optionIndex].value,
            }}
          >
            I'm a paragraph with <code>text-align: justify;</code>! 👋 Doggo
            ipsum shoob long water shoob h*ck smol fat boi, vvv wow very biscit.
            shibe heckin good boys and girls shoob.{' '}
          </p>
        </div>
      </div>
    </PlaygroundWrapper>
  );
};

const renderComponent = (props, container) => {
  const root = createRoot(container);
  root.render(React.createElement(TextAlignLastExplainer, props));
};

export { renderComponent, styles };
export default TextAlignLastExplainer;
